<template>
  <PVProgressSpinner
    class="spinner-wrapper"
    :style="{
      height: spinnerHeight,
      width: spinnerHeight,
    }"
  />
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { SpinnerSize } from './SpinnerWrapper.types';

  const { size = SpinnerSize.M } = defineProps<{
    size?: SpinnerSize;
  }>();

  const spinnerHeight = computed(() => {
    switch (size) {
      case SpinnerSize.S:
        return '1rem';
      case SpinnerSize.M:
        return '1.5rem';
      case SpinnerSize.ML:
        return '2rem';
      case SpinnerSize.L:
        return '3rem';
      case SpinnerSize.XL:
        return '6.25rem';
      default:
        throw new Error(`Unknown spinner size: ${size}`);
    }
  });
</script>
